const LANGUAGE_MIGRATIONS = {
  'zh-CN': 'zh-Hans',
  'zh-TW': 'zh-Hant',
};
export default LANGUAGE_MIGRATIONS;
